export const generateViewId = (...ids: string[]): string => ids.join('/');
